import type { FlexProps } from '@mantine/core';
import { Flex } from '@mantine/core';
import { forwardRef } from 'react';

export const LBFixedSection = forwardRef<HTMLDivElement, FlexProps>(
  ({ children, style, ...props }, ref) => (
    <Flex
      ref={ref}
      // bottom={50}
      bottom={0}
      direction='column'
      gap={8}
      left='50%'
      maw={400}
      miw={260}
      pos='fixed'
      // w='90%'
      w='100%'
      style={{
        transform: 'translateX(-50%)',
        zIndex: 200,
        ...style
      }}
      {...props}
    >
      {children}
    </Flex>
  )
);
